// Chamadas ao servidor do Ordo.

let settings = { apiUrl: "", token: "" };

export function configure(s) {
  settings = s;
}

export const apiBase = () => settings.apiUrl.replace(/\/+$/, "");
export const apiToken = () => settings.token;

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
    this.fatal = status === 401;
  }
}

export async function api(method, path, body, { raw = false, contentType, timeout = 30000 } = {}) {
  if (!settings.token) throw new ApiError(401, "Entre na sua conta.");
  const headers = { Authorization: `Bearer ${settings.token}` };
  let payload = body;
  if (raw) headers["Content-Type"] = contentType || "application/octet-stream";
  else if (body !== undefined) {
    headers["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeout);
  let res;
  try {
    res = await fetch(apiBase() + path, { method, headers, body: payload, signal: ctrl.signal });
  } catch (err) {
    throw new ApiError(0, err.name === "AbortError" ? "O servidor demorou para responder." : "Sem conexão com o servidor.");
  } finally {
    clearTimeout(timer);
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.error || `Erro ${res.status}`);
  return data;
}

export async function publicPost(path, body) {
  const res = await fetch(apiBase() + path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).catch(() => { throw new ApiError(0, "Sem conexão com o servidor."); });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.error || `Erro ${res.status}`);
  return data;
}

export async function uploadFile(file, name) {
  const q = encodeURIComponent(name || file.name || "arquivo");
  return api("POST", `/files?name=${q}`, file, { raw: true, contentType: file.type || "application/octet-stream", timeout: 120000 });
}

// Resposta crua (áudio, streaming). Lança ApiError quando o status não é 2xx.
export async function apiFetch(method, path, body, { signal } = {}) {
  if (!settings.token) throw new ApiError(401, "Entre na sua conta.");
  const headers = { Authorization: `Bearer ${settings.token}` };
  if (body !== undefined) headers["Content-Type"] = "application/json";
  let res;
  try {
    res = await fetch(apiBase() + path, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), signal });
  } catch (err) {
    if (err.name === "AbortError") throw err;
    throw new ApiError(0, "Sem conexão com o servidor.");
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new ApiError(res.status, data.error || `Erro ${res.status}`);
  }
  return res;
}
